import emailjs from 'emailjs-com';
import { Form, Input, Button, message } from 'antd';
import './CustomizedTraining.css'; // External CSS file for styling
import image from '../assets/images/customtrain1.jpg'; // Image for visual appeal

const CustomizedTraining = () => {
  const [form] = Form.useForm();

  // Send email function using EmailJS
  const sendEmail = (values) => {
    const emailParams = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      subject: values.subject,
      message: values.message,
    };

    emailjs
      .send(
        'service_oit4bk9', // Your service ID
        'template_xny0vd6', // Your template ID
        emailParams,
        '6xlgr_2EFvcPEjnDG' // Your user ID
      )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        message.success('Message sent successfully!');

        // Clear the form after submission
        form.resetFields();
      })
      .catch((err) => {
        console.error('FAILED...', err);
        message.error('Failed to send the message. Please try again later.');
      });
  };

  return (
    
    <div className="custom-training-container">
      
      {/* Image Section */}
      <div className="custom-training-image-container">
        <img
          src={image}
          alt="Customized Training"
          className="custom-training-image"
        />
        <h1 style={{display:'flex',justifyContent:'center' , padding:'15px'}}>Customized Training</h1>
      </div>

      {/* Main Content Section */}
      <div className="custom-training-content">
        {/* Left side with bullet points */}
        <div className="custom-training-left">
          {/* <br /> */}
          <p >Custom training is a special training for a specific requirement for candidates who wants training at individual level to get trained on  focused  niche areas. </p>
          <p>Who should opt for this training</p>
          <ul>
            <li>Have (or foresee) a technical challenge at work spot and need help / training</li>
            <li>Special technical domain which is not listed as part of the  regular course schedule</li>
            <li>Need an individual attention to get trained and coached for an upcoming exam</li>
            <li>Need to complete a project (for academics/others) that needs assistance</li>
            <li>Need to train a team at your corporate office for an upcoming project on a focussed technical area</li>
            <br />
            <br />
            <p>What you will get</p>
            <ul>
              <li>Flexe timing schedule based on your availability</li>
              <li>Training on the list of topics that is customized for your needs</li>
              <li>Individual attention</li>
              <li>Opportunity to unlimited assistance from the expert </li>
              <li>Once you register, expect an email from Chosen IT Academy about the allocation. </li>
            </ul>
          </ul>
        </div>

        {/* Right side with form */}
        <div className="custom-training-right">
          <h2 style={{justifyContent:'center', display:'flex'}}>Customized Training Enquiry</h2>
          <Form
            form={form}
            onFinish={sendEmail}
            layout="vertical"
            className="custom-training-form"
          >
            {/* Name Field */}
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: 'Please enter your name' },
                { min: 2, message: 'Name must be at least 2 characters long' },
              ]}
            >
              <Input
                type="text"
                placeholder="Enter your name"
                className="custom-training-input"
              />
            </Form.Item>

            {/* Phone Field */}
            <Form.Item
              label="Phone"
              name="phone"
              rules={[
                { required: true, message: 'Please enter your phone number' },
                {
                  pattern: /^[0-9]{10}$/,
                  message: 'Phone number must be 10 digits long',
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Enter your phone number"
                className="custom-training-input"
              />
            </Form.Item>
            

            {/* Email Field */}
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email' },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
              ]}
            >
              <Input
                type="email"
                placeholder="Enter your email"
                className="custom-training-input"
              />
            </Form.Item>

            {/* Subject Field */}
            <Form.Item
              label="Subject"
              name="subject"
              rules={[{ required: true, message: 'Please enter the subject' }]}
            >
              <Input
                type="text"
                placeholder="Enter the subject"
                className="custom-training-input"
              />
            </Form.Item>

            {/* Message Field */}
            <Form.Item
              label="Message"
              name="message"
              rules={[
                { required: true, message: 'Please enter your message' },
                { min: 10, message: 'Message must be at least 10 characters long' },
              ]}
            >
              <Input.TextArea
                placeholder="Enter your message"
                className="custom-training-textarea"
                rows={4}
              />
            </Form.Item>

            {/* Submit Button */}
            <Button
              type="primary"
              htmlType="submit"
              size="middle"
              block
              className="custom-training-button"
            >
              Send Enquiry
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CustomizedTraining;
